import { CoachesContainer } from "./components";
import { CoachesContextProvider } from "./context/CoachesContext";

const Coaches: React.FC = () => {
  return (
    <CoachesContextProvider>
      <CoachesContainer />
    </CoachesContextProvider>
  );
};

export default Coaches;
